function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-68.686 -635.166)"
}, /*#__PURE__*/React.createElement("g", {
  id: "leafy",
  transform: "translate(68.686 635.166)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M191.725,275.441c5.587,4.676,5.826,14.455-2.122,21.551-10.851,9.684-34.317,14.841-55.852-.59-39.025-32.377-26.587-91.875-4.574-123.075C141.871,234.769,144.178,235.647,191.725,275.441Z",
  transform: "translate(-49.527 -79.968)",
  fill: "#6dc4f2",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M33.831,197.538c-6.884,15.32-43.4,2.267-31.447-40.308C19.239,111,78.622,114.553,110.711,118.546c-32.105,14.447-51.43,22.381-76.88,78.989v0Z",
  transform: "translate(0 -53.693)",
  fill: "#ffd13c",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M123.008,34.954c-17.67-1.374-14.43-31.227,32.355-34.949,52.108-.623,62.273,49.436,70.474,79.769-27.6-25.379-37.62-39.761-102.83-44.82Z",
  transform: "translate(-51.639 0.001)",
  fill: "#33d5ba",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M329.146,67.127c-3.772-17.56,30.154-23.34,48.254,20.95,16.269,50.38-35.947,75.215-66.975,92.245,19.76-34.372,32.636-48.4,18.724-113.2Z",
  transform: "translate(-141.724 -24.937)",
  fill: "#ff4d3d",
  fillRule: "evenodd"
})));
function SvgLeafySmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 238.746,
    height: 226.224,
    viewBox: "0 0 238.746 226.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafySmall);
export default __webpack_public_path__ + "static/media/leafy_small.17f072c81e6a9cc66848374775cf2ed0.svg";
export { ForwardRef as ReactComponent };